'use strict';
import React, { useState, useEffect } from 'react';
import { Tabs, Toast } from 'antd-mobile'
import { themeStore } from '../../store';
import styles from './assets/index.module.scss';
import { useNavigate } from "react-router-dom";
import Header from '../common/Header';
import Emptyer from '../../utils/Emptyer';
import Loading from '../../utils/Loading';

export default function DDS_lanhupage_0() {

  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState('company');
  const [local, setLocal] = useState({
    company: [],
    dept: [],
    loading: true,
  });
  const { company, dept, isCompanyFinished } = themeStore;

  useEffect(() => {
    setLocal({
      loading: false,
      company,
      dept
    })
    isCompanyFinished && setActiveKey('deptment')
  }, [company, dept])

  const active = (themeId, themeName, finished, total) => {
    // if (finished !== total) {
    navigate(`/lanhu_5?themeId=${themeId}&themeName=${themeName}`);
    // }
  }

  const tabChange = str => {
    setActiveKey(str)
  }

  const eachTheme = (category) => {
    if (local.loading) {
      return <Loading />
    }
    if (category.length === 0) {
      return <Emptyer />
    }
    return (
      <div className={`${styles.bd4} flex-col`}>
        {/**公司级课程**/}
        <div className={`${styles.section2} flex-col justify-start`}>
          {
            category.map(({ imgUrl, themeId, themeName, knowledgeStudyedNumber, totalNumber }, i) => (
              <div key={themeId + i} onClick={() => active(themeId, themeName, knowledgeStudyedNumber, totalNumber)}>
                <div className={`${styles.bd5} flex-row justify-between`}>
                  <div className={`${styles.box1} flex-col`}>
                    <img
                      className={`${styles.pic1}`}
                      src={imgUrl.replace('http://192.169.250.225:8888', 'https://onlinetest.shasteel.cn')}
                    />
                  </div>
                  <div className={`${styles.TextGroup1} flex-col`}>
                    <div className={`${styles.group1} flex-col`}>
                      <span className={`${styles.word1}`}>{themeName}</span>
                      <span className={`${styles.word2}`}>已完成{(knowledgeStudyedNumber / totalNumber).toFixed(2) * 100}%</span>
                      <span className={`${styles.word3}`}>共{totalNumber}个知识点</span>
                    </div>
                  </div>
                </div>
                {i < category.length - 1 && (
                  <img
                    className={`${styles.img1}`}
                    src={
                      require('./assets/img/SketchPng2a2b39252316f295592dca01fb91c06dee0a6cf9636c62befc29878553cfb646.png')
                    }
                  />
                )}
              </div>
            ))
          }
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.page} flex-col`}>
      <div className={`${styles.section1} flex-col`}>
        <div className={`${styles.layer1} flex-col`}>
          {/* <Header className={`${styles.bd1} flex-col`} /> */}
          <Tabs className={`${styles.myTabs}`} activeKey={activeKey} onChange={str => tabChange(str)}>
            <Tabs.Tab title='公司级课程' key='company'>
              {eachTheme(local.company)}
            </Tabs.Tab>
            <Tabs.Tab title='部门级课程' key='deptment'>
              {eachTheme(local.dept)}
            </Tabs.Tab>
          </Tabs>

          {/* <div className={`${styles.bd2} flex-row justify-between`}>
            <span className={`${styles.txt1}`}>公司级课程</span>
            <span className={`${styles.txt2}`}>部门级课程</span>
          </div>
          <div className={`${styles.bd3} flex-col`} /> */}

        </div >
      </div >
    </div >
  );
}
